import type { FC, ReactNode } from 'react';

/**
 * Ports the prototype's `.kpi-mini`: a 13px semibold title with an optional 11px muted subtitle
 * on the left, a 15–16px extra-bold figure on the right, and a divider between rows but not
 * after the last one.
 */
interface KpiMiniRowProps {
  title: ReactNode;
  subtitle?: ReactNode;
  value: string;
  /** Colour for the figure — an @theme token. Defaults to normal ink. */
  valueColor?: string;
}

const KpiMiniRow: FC<KpiMiniRowProps> = ({ title, subtitle, value, valueColor }) => (
  <div className="flex items-center justify-between border-b border-[var(--color-divider)] py-2.5 last:border-b-0">
    <div>
      <div className="text-[13px] font-semibold text-[var(--color-ink)]">{title}</div>
      {subtitle ? (
        <div className="text-[11px] text-[var(--color-ink-muted)]">{subtitle}</div>
      ) : null}
    </div>
    <div
      className="text-[15px] font-extrabold"
      style={{ color: valueColor ?? 'var(--color-ink)' }}
    >
      {value}
    </div>
  </div>
);

export default KpiMiniRow;
